<ion-header [translucent]="true">
	<ion-toolbar>
		<ion-title>
			<span class="highlight">{{ 'paypal.title' | translate }}</span>
		</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<h1 class="ion-no-margin ion-text-bold ion-text-center" style="font-size: 4rem">
		{{ formattedTotalPrice }}
	</h1>

	@if (!errorMessage) {
		<div class="ion-text-center ion-padding">
			<ion-spinner></ion-spinner>
			<p>{{ 'paypal.waitingForApproval' | translate }}</p>
		</div>

		<div class="ion-padding-horizontal" style="display: flex; flex-direction: column; gap: 8px">
			<ion-button (click)="openPaypal()" expand="block" fill="outline">
				{{ 'paypal.openPaypal' | translate }}
			</ion-button>
		</div>
	}

	@if (errorMessage) {
		<p class="ion-text-center ion-padding error-message">{{ errorMessage }}</p>
		<div class="ion-padding-horizontal" style="display: flex; flex-direction: column; gap: 8px">
			<ion-button (click)="openPaypal()" expand="block" fill="outline">
				{{ 'paypal.openPaypal' | translate }}
			</ion-button>
		</div>
	}
</ion-content>
<ion-footer class="ion-padding">
	@if (paySessionStatistics?.tipsValue) {
		<app-info-row>
			<div left>{{ 'common.tipLabel' | translate }}</div>
			<div right>{{ formattedTips }}</div>
		</app-info-row>
	}
	<hr class="divider" />
	<app-info-row>
		<div left>
			{{ 'statistics.total' | translate }} (<span>{{ paySessionStatistics?.selectedProductsCount }}</span> &nbsp;{{
				'statistics.items' | translate
			}})
		</div>
		<div right>{{ formattedTotalPrice }}</div>
	</app-info-row>
</ion-footer>
